export enum BadgeVariant {
    ERROR = 'error',
    WARNING = 'warning',
    SUCCESS = 'success',
    INFO = 'info',
  }
  
  export enum AlertVariant {
    BRAND = 'brand',
    ERROR = 'error',
    WARNING = 'warning',
    SUCCESS = 'success',
    NEUTRAL = 'neutral'
  }
  
  export enum IconSize {
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large'
  }
  
  export interface ActionButton {
  label: string;
  icon: string;
  variant?: 'default' | 'brand-secondary';
  onClick: () => void;
}

export enum ContactMethod {
  PHONE_CALL = 'PHONE_CALL',
  MESSAGE = 'MESSAGE',
  VOICEMAIL = 'VOICEMAIL',
  EMAIL = 'EMAIL',
  IN_PERSON = 'IN_PERSON',
  VIDEO_CALL = 'VIDEO_CALL'
}

export const ContactMethodDisplayMap: Record<ContactMethod, string> = {
  [ContactMethod.PHONE_CALL]: 'Phone Call',
  [ContactMethod.MESSAGE]: 'Message',
  [ContactMethod.VOICEMAIL]: 'Voicemail',
  [ContactMethod.EMAIL]: 'Email',
  [ContactMethod.IN_PERSON]: 'In Person',
  [ContactMethod.VIDEO_CALL]: 'Video Call'
};

export const getContactMethodDisplayText = (contactMethod: string): string => {
  return ContactMethodDisplayMap[contactMethod as ContactMethod] || contactMethod;
};

export enum OutcomeValue {
  SUCCESSFUL = 'SUCCESSFUL',
  NEEDS_ATTENTION = 'NEEDS_ATTENTION',
  OTHER = 'OTHER',
  DISMISS = 'DISMISS',
  NO_SELECTION = 'NO_SELECTION'
}

export const OutcomeDisplayMap: Record<OutcomeValue, string> = {
  [OutcomeValue.SUCCESSFUL]: 'Resolved',
  [OutcomeValue.NEEDS_ATTENTION]: 'In Progress',
  [OutcomeValue.OTHER]: 'Other',
  [OutcomeValue.DISMISS]: 'Dismissed',
  [OutcomeValue.NO_SELECTION]: 'No Selection'
};

export const getOutcomeDisplayText = (outcome: string): string => {
  return OutcomeDisplayMap[outcome as OutcomeValue] || outcome;
}; 